import { Inject, Injectable, PLATFORM_ID  } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ScriptService {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  public injectJsonLdScript(): void {

    if (isPlatformBrowser(this.platformId)) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = `{
      "@context": "https://schema.org/",
      "@type": "Product",
      "name": "Estate Planning, Funeral & Healthcare Directives, Catholic Will, Funeral planning",
      "image": ["https://catholiclegacy.com/assets/images/logo_new.png"],
      "description": "Catholic Legacy offers free, faith-based estate planning tools tailored for Catholics. Our comprehensive, user-friendly resources enable individuals to create legally sound wills, healthcare directives, and funeral plans that align with Catholic values. Catholic Legacy supports families in building lasting legacies, ensuring peace of mind and honoring their faith through every step.",
      "brand": {
        "@type": "Thing",
        "name": "Catholic Legacy"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.4",
        "ratingCount": "30"
      },
      "offers": {
        "@type": "Offer",
        "priceCurrency": "USD",
        "price": "40"
      }
    }`;

      document.head.appendChild(script);
    }
  }
}